module.exports = __webpack_public_path__ + "img/tsumugi_1.d94f9954.png";